<template lang="pug">
v-data-table.x-data-table(
  item-key="@index"
  :items="rows"
  :headers="cols"
  :items-per-page="-1"
  :height="height"

  :value="selection"
  @input="value => $emit('input',value)"

  :show-select="showSelect && !!rows.length"
  :single-select="singleSelect"

  dense
  fixed-header
  calculate-widths
  disable-filtering
  disable-sort
  disable-pagination
  hide-default-footer
  no-data-text="Nenhum dado disponível"
  loading-text="Pesquisando dados..."

  :item-class="getRowClass"
)
  //-@click:row="item => call(getRowLink(item), [ item ])"
  //- @item-selected="itemSelected"
  //- :show-select="rows && rows.length ? true : false"

  template(
    v-for="col in cols"
    #[`item.${col.value}`]="{ item, index }"
  )
    grid-table-data-cell(
      :item="item"
      :col="col"
      @perform="args => $emit('perform', args)"
    )

  template(#footer)
    v-card.px-2.d-flex.flex-row-reverse(flat tile)
      div.pa-1.text-caption {{ count == 1 ? `${count} registro` : `${count} registros` }}

  template(#item.data-table-select="{ item, isSelected, select }")
    v-simple-checkbox(v-if="!isRowNonSelectable(item)" :value="isSelected" @input="select($event)")

</template>

<style>
.x-row-pointer >>> tbody td:hover {
  cursor: pointer;
}
.x-icon {
  padding: 0 !important;
}
</style>

<script>
import { hasRel, findRel } from "@/helpers/rels"
import GridTableDataCell from './GridTableDataCell'

export default {
  components: {
    GridTableDataCell,
  },

  props: {

    /**
     * A entidade em exibição.
     * @type {Keep.Paper.Design.Paper}
     */
    entity: Object,

    /**
     * Coleção dos registros selecionados.
     * @type {Array}
     */
    selection: Array,

    /**
     * A coleção de registros exibidos.
     * @type {Keep.Paper.Design.Set}
     */
    set: Object,

    /**
     * Controla a exibição da caixa de seleção de registros.
     * @type {Boolean}
     */
    showSelect: Boolean,

    /**
     * Ativa a seleção de único registro em vez de vários.
     * @type {Boolean}
     */
    singleSelect: Boolean,

    /**
     * Altura da grade.
     * @type {Integer | String}
     */
    height: {
      valitadion: v => true,
    },
  },

  data: () => ({
    lastSelectedItem: null,
    shiftKey: false,
  }),

  computed: {

    hasSet() {
      return !!this.set
    },

    // Coleção dos cabeçalhos como declarados no Set...
    headers() {
      return this.set?.headers || [];
    },

    count() {
      return this.rows.length
    },

    // Coleção dos registros como declarados no Set...
    rows() {
      const rows = (this.set?.rows || [])
      rows.forEach(row => {
        let index = row['@row']
        if (typeof index === 'object') {
          index = index.value
        }
        row['@index'] = index || rows.indexOf(row)
      })
      return rows
    },

    // Coleção das colunas da grade criadas a partir dos cabeçalhos do Set...
    cols() {
      const visibleHeaders = this.headers.filter((header) => !header.hidden);

      const hasActs = this.rows?.some(row => {
        const links = row?.['@row']?.links || {}
        return hasRel(links, "Action")
      })

      let cols = [
        ...visibleHeaders.map((header) => this.createColumn(header)),
        {
          text: ' ',
          width: '99%',
          header: {}
        }
      ]

      if (hasActs) {
        cols = [
          this.createColumn({
            name: "#l-links",
            title: " ",
            actions: {
              criteria: { includes: [ "Action", "Pinned", "Primary" ] },
              pinned: "left",
            },
            class: 'x-icon'
          }),
          ...cols
        ]
      }

      if (hasActs) {
        cols = [
          ...cols,
          this.createColumn({
            name: "#r-links",
            title: " ",
            actions: {
              criteria: { includes: [ "Action", "Pinned" ], excludes: [ "Primary" ] },
              pinned: "right",
            },
            class: 'x-icon'
          })
        ]
      }

      return cols;
    },
  },

  methods: {
    // header: Uma instância de {Keep.Tools.Design.Header}.
    createColumn(header) {
      let useBadge = hasRel(header, 'Badge')
      let useIcon = hasRel(header, 'Icon')
      if (useIcon) header.class = 'x-icon'
      let col = {
        // data table properties
        value: header.name,
        text: header.title || header.name,
        align: (useBadge || useIcon) ? "center" : this.getAlign(header),

        // text: string,
        // value: string,
        // align?: 'start' | 'center' | 'end',
        // sortable?: boolean,
        // filterable?: boolean,
        // groupable?: boolean,
        // divider?: boolean,
        // width?: string | number,
        // filter?: (value: any, search: string, item: any) => boolean,
        // sort?: (a: any, b: any) => number

        width: header.name === '#menu' ? 10 : null,
        // class: 'x-nowrap',
        cellClass: header.class,

        // custom properties
        header,
        useBadge,
        useIcon,
      };

      return col;
    },

    //
    // * Tratamentos de tecla...
    //
    registerKeyHandler (register) {
      if (register) {
        window.addEventListener("keydown", this.keyHandler);
        window.addEventListener("keyup", this.keyHandler);
      } else {
        window.removeEventListener("keydown", this.keyHandler);
        window.removeEventListener("keyup", this.keyHandler);
      }
    },

    keyHandler (event) {
      if (event.key === "Shift") {
        this.shiftKey = event.type === "keydown";
      }
    },

    isRowNonSelectable(row) {
      return row?.['@row']?.nonSelectable || hasRel(row?.['@row'], "Summary")
    },

    getRowLinks (row) {
      return row['@row']?.links || []
    },

    getRowLink (row) {
      const links = this.getRowLinks(row)
      const link = findRel(links, { includes: ['Action', 'Primary'], excludes: "Pinned" } )
      return link
    },

    getRowClass (row) {
      const link = this.getRowLink(row)
      return {
        'text-no-wrap': true,
        'x-link': !!link,
      }
    },

    call (link, selection) {
      if (link) this.$emit('perform', { link, selection })
    },

    getAlign (header) {
      if (header.name === '#menu') return 'left'
      if (header.actions?.pinned) return header.actions.pinned
      if (header.align === 1 || header.align === 'Left') return 'left'
      if (header.align === 2 || header.align === 'Center') return 'center'
      if (header.align === 3 || header.align === 'Right') return 'right'
      return {
          1: "start",
          2: "center",
          3: "end",
          Left: "start",
          Center: "center",
          Right: "end",
        }[header.align]
      || {
          Boolean: "center",
          Integer: "end",
          Long: "end",
          Decimal: "end",
          Date: "center",
          Time: "center",
          DateTime: "center",
          TimeSpan: "center",
        }[header.dataType]
      || "start"
    },
  },

  watch: {
    // set: "valueChanged",
  },

  created () {
    this.registerKeyHandler(true);
  },

  beforeDestroy () {
    this.registerKeyHandler(false);
  },
};
</script>
